<div class="pt-2" [ngStyle]="{ height: height + 'px'} ">
  <!--<p-progressSpinner></p-progressSpinner>-->
  <div
    *ngFor="let rowNumber of rows | enumerate : true; let i = index"
    class="flex gap-3"
    style="margin-bottom: 12px;"
    [ngStyle]="{
      height: ((height / rows) - 12) + 'px'
    }"
  >
    <div class="flex">
      <p-skeleton height="100%" width="4rem"></p-skeleton>
    </div>
    <div class="flex">
      <p-skeleton height="100%" width="12rem"></p-skeleton>
    </div>
    <div class="flex flex-grow-1">
      <p-skeleton
        [width]="minLength + ((maxLength - minLength) / rows) * rowNumber + 'rem'"
        height="100%"
      ></p-skeleton>
      <div
        class="flex flex-column justify-content-center ml-2 align-content-start"
      >
        <div class="flex">
          <p-skeleton height="0.75rem" width="10rem"></p-skeleton>
        </div>
        <div class="flex mt-1">
          <p-skeleton height="0.6rem" width="15rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>
<!--<p-skeleton width="5rem" height="2rem"></p-skeleton><p-skeleton width="10rem" height="2rem" class="ml-3"></p-skeleton><p-skeleton width="30rem" height="2rem" class="ml-3"></p-skeleton>-->